import React, { FC } from 'react';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { useSelectedPoolsStore } from '../../../../context/selected-pools.store';
import { Pool, PoolPlansTab, PoolsPlansTableColumnTitle } from '../../../../types/pool-plans.types';
import { ScrollablePoolItem, StickyPoolItem } from './pool-item';

type StickyPoolTableProps = {
  date: Date;
  pools: Pool[];
  selectedTab: PoolPlansTab;
};

export const StickyPoolTable: FC<StickyPoolTableProps> = ({ pools, selectedTab, date }) => {
  const { poolState } = useSelectedPoolsStore();
  return (
    <table className="h-fit transition-all">
      <thead>
        <tr className="flex border-y-[1px] border-[#F2F2F2] bg-gray-50">
          <td className="relative">
            <div className="flex h-full w-[48px] items-center justify-center"> </div>
          </td>
          <td className="px-4 py-3">
            <div className="flex items-center">
              <span className="min-w-[210px] max-w-[320px] text-label-md font-[450] text-[#172335]">
                Pool
              </span>
            </div>
          </td>
        </tr>
      </thead>
      <tbody>
        {pools && (
          <>
            {pools.map((pool) => (
              <StickyPoolItem
                date={date}
                isSelected={poolState.poolId.includes(pool.id)}
                key={pool.id}
                pool={pool}
                selectedTab={selectedTab}
              />
            ))}
          </>
        )}
      </tbody>
    </table>
  );
};

export type ScrollablePoolTableProps = {
  date: Date;
  onDeleteClick: (id: string) => void;
  onDeletePlanClick: (id: string) => void;
  onEditClick: (id: string) => void;
  onEditPlanClick: (id: string) => void;
  onEditPlanTerminationDateClick: (id: string) => void;
  onEditTerminationDateClick: (id: string) => void;
  onViewClick: (id: string) => void;
  onViewPlanClick: (id: string) => void;
  pools: Pool[] | undefined;
  selectedTab: PoolPlansTab;
};

const tableColumns = Object.values(PoolsPlansTableColumnTitle);

export const ScrollablePoolTable: FC<ScrollablePoolTableProps> = ({
  pools,
  selectedTab,
  onEditClick,
  onViewClick,
  onDeleteClick,
  onEditPlanClick,
  onViewPlanClick,
  onDeletePlanClick,
  onEditTerminationDateClick,
  onEditPlanTerminationDateClick,
  date,
}) => {
  const { poolState } = useSelectedPoolsStore();
  return (
    <table className="w-full transition-all">
      <thead>
        <tr className="border-y-[1px] border-[#F2F2F2] bg-gray-50">
          {tableColumns.map((column) => (
            <td className="px-4 py-3" key={column}>
              <div className="flex items-center">
                <span className="whitespace-nowrap text-label-md font-[450] text-[#172335]">
                  <AppFormattedMessage id={column} />
                </span>
              </div>
            </td>
          ))}
          <td className="relative">
            <div className="flex h-full w-full items-center justify-center px-6"></div>
          </td>
        </tr>
      </thead>
      <tbody>
        {pools && (
          <>
            {pools.map((pool) => (
              <ScrollablePoolItem
                date={date}
                isSelected={poolState.poolId.includes(pool.id)}
                key={pool.id}
                onDeleteClick={onDeleteClick}
                onDeletePlanClick={onDeletePlanClick}
                onEditClick={onEditClick}
                onEditPlanClick={onEditPlanClick}
                onEditPlanTerminationDateClick={onEditPlanTerminationDateClick}
                onEditTerminationDateClick={onEditTerminationDateClick}
                onViewClick={onViewClick}
                onViewPlanClick={onViewPlanClick}
                pool={pool}
                selectedTab={selectedTab}
              />
            ))}
          </>
        )}
      </tbody>
    </table>
  );
};
